import { createRef } from "react";
import { create } from "zustand";

export interface ISuccessModalState {
  isShowModal: boolean;
  continueButtonRef: React.RefObject<HTMLButtonElement>;
  setShowModal: (val: boolean) => void;
}

const useSuccessModalStore = create<ISuccessModalState>((set) => ({
  isShowModal: false,
  continueButtonRef: createRef<HTMLButtonElement>(),
  setShowModal: (isShowModal) => set(() => ({ isShowModal })),
}));

export default useSuccessModalStore;
